/*
 * Hides the "Delivery Information" section inside product description
 * bodies on product templates. The heading + all following siblings
 * are hidden up to the next same-or-higher-level heading (so the
 * next section — e.g. Ingredients — is preserved).
 *
 * Targets the block-configured description inside
 * .ai-product-description__text-* (AI product description block).
 *
 * The "Delivery Information" text may appear as a real heading (h2..h6)
 * or as a bold paragraph — both are supported.
 */
(function () {
  var TARGET_TEXT = 'delivery information';

  function normText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isHeading(el) {
    return el && /^H[1-6]$/.test(el.tagName);
  }

  function headingLevel(el) {
    return parseInt(el.tagName.slice(1), 10);
  }

  function hideFrom(startEl, stopLevel) {
    startEl.style.display = 'none';
    var next = startEl.nextElementSibling;
    while (next) {
      if (isHeading(next)) {
        if (stopLevel === null) break;
        if (headingLevel(next) <= stopLevel) break;
      }
      var toHide = next;
      next = next.nextElementSibling;
      toHide.style.display = 'none';
    }
  }

  function processContainer(container) {
    if (!container || container.dataset.deliveryInfoProcessed === '1') return;
    container.dataset.deliveryInfoProcessed = '1';

    // 1) Real headings whose text matches.
    var headings = container.querySelectorAll('h1, h2, h3, h4, h5, h6');
    headings.forEach(function (h) {
      if (normText(h) !== TARGET_TEXT) return;
      hideFrom(h, headingLevel(h));
    });

    // 2) Bold/strong paragraphs used as a pseudo-heading, e.g.
    //    <p><strong>Delivery Information</strong></p>. Hide the whole
    //    <p>, then hide following siblings until the next paragraph
    //    that starts with a bold/strong (next pseudo-heading) or a
    //    real heading.
    var pseudo = container.querySelectorAll('p > strong:only-child, p > b:only-child');
    pseudo.forEach(function (s) {
      var p = s.parentElement;
      if (!p || normText(p) !== TARGET_TEXT) return;
      if (p.style.display === 'none') return;
      p.style.display = 'none';
      var next = p.nextElementSibling;
      while (next) {
        if (isHeading(next)) break;
        // Stop at the next pseudo-heading paragraph (a <p> whose
        // only child is a <strong>/<b>).
        if (next.tagName === 'P') {
          var only = next.children.length === 1 ? next.children[0] : null;
          if (only && (only.tagName === 'STRONG' || only.tagName === 'B')) break;
        }
        var toHide = next;
        next = next.nextElementSibling;
        toHide.style.display = 'none';
      }
    });
  }

  function run() {
    var containers = document.querySelectorAll(
      '[class*="ai-product-description__text-"]'
    );
    containers.forEach(processContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
